import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {TARMAC} from '../../../style/colors';
import glamorous from 'glamorous';
import {PHONE} from '../../../style/breakpoints';
import StatsCard from '../stats/release-info';
import {MOBILE_PADDING} from '../card';
import {formatCount} from '../../../utils/format';

const DESKTOP_MARGIN = 45;
const MOBILE_MARGIN = 25;

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  [PHONE]: {
    padding: MOBILE_PADDING,
    paddingLeft: 5
  },
  ' > div > div': {
    marginLeft: DESKTOP_MARGIN,
    [PHONE]: {
      marginLeft: MOBILE_MARGIN
    }
  }
});

const Placeholder = glamorous.div({
  ...BASE_TEXT,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontsize: 14,
  color: TARMAC,
  fontStyle: 'italic',
  textAlign: 'center'
});

const ReleaseInfo = ({latestVersionNumber, license, placeholder = 'No Release Info found'}) => {
  let items = [];
  if (latestVersionNumber) {
    items.push({
      stat: formatCount(latestVersionNumber),
      label: 'Latest version'
    });
  }
  return (
    <Container>
      {items.length > 0 ? (
        <StatsCard items={items} license={license} />
      ) : (
        <Placeholder>{placeholder}</Placeholder>
      )}
    </Container>
  );
};

ReleaseInfo.propTypes = {
  latestVersionNumber: PropTypes.number,
  license: PropTypes.object,
  placeholder: PropTypes.string
};

export default ReleaseInfo;
